<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section
      :title="$t('Integrations_Settings_ConnectionSettings')"
      v-if="model.id"
    >
      <rest-form-item
        :label="$t('Integrations_Segment_Field_Token')"
        prop="token"
      >
        <integration-token-input v-model="model.token" />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import IntegrationTokenInput from '@/modules/integrations/components/IntegrationTokenInput'

export default {
  name: 'SegmentSettings',

  components: {
    FormSection,
    RestFormItem,
    IntegrationTokenInput
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/segment/SegmentSettings.vue